import { Controller } from "@hotwired/stimulus"

// Handles bulk selection with checkboxes for tables
// Provides select all, individual selection, and count display
export default class extends Controller {
  static targets = ["selectAll", "checkbox", "count", "deleteButton"]

  connect() {
    this.updateCount()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
    this.updateCount()
  }

  updateCount() {
    const checkedCount = this.checkboxTargets.filter(cb => cb.checked).length
    const totalCount = this.checkboxTargets.length

    // Update count display
    if (this.hasCountTarget) {
      this.countTarget.textContent = `${checkedCount} selected`
    }

    // Update select all checkbox state
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = checkedCount === totalCount && totalCount > 0
      this.selectAllTarget.indeterminate = checkedCount > 0 && checkedCount < totalCount
    }

    // Enable/disable delete button
    if (this.hasDeleteButtonTarget) {
      this.deleteButtonTarget.disabled = checkedCount === 0
    }
  }
}
